'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = require('lodash');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SizeStore = function () {
  function SizeStore(size) {
    _classCallCheck(this, SizeStore);

    this.size = size;
    this.subscriptions = [];
  }

  _createClass(SizeStore, [{
    key: 'setSize',
    value: function setSize(size) {
      this.size = size;
      this.subscriptions.forEach(function (subscription) {
        return subscription();
      });
    }
  }, {
    key: 'subscribe',
    value: function subscribe(subscription) {
      this.subscriptions.push(subscription);
    }
  }, {
    key: 'unsubscribe',
    value: function unsubscribe(subscription) {
      (0, _lodash.remove)(this.subscriptions, function (sub) {
        return sub === subscription;
      });
    }
  }]);

  return SizeStore;
}();

exports.default = SizeStore;


//////////////////
// WEBPACK FOOTER
// ./node_modules/reactive-container/dist/SizeStore.js
// module id = 1456
// module chunks = 2